module.exports = __webpack_public_path__ + "static/media/flv.c61c8478.svg";